namespace GeniuzPOS.InitialData {
    export class PsOtherPaymentColumns {
        static columnsKey = 'InitialData.PsOtherPayment';
    }
}
